import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {ReleaseInfo} from '../models';

@Injectable()
export class ReleaseInfoService {
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

  public getReleaseInfo(): Observable<[ReleaseInfo]> {
    return this.http.get<[ReleaseInfo]>(this.baseUrl + '/api/versioninfotext');
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/services/releaseInfo.service.ts